// Shim for @tanstack/react-start — provides createServerFn as a client-side
// chained builder that mimics the server-side API. This allows the surviving
// .functions.ts files to work without a server runtime.

type AnyFn = (...args: any[]) => any;

interface ServerFnBuilder {
  middleware(_mw: any): ServerFnBuilder;
  inputValidator(_schema: any): ServerFnBuilder;
  handler(fn: AnyFn): AnyFn;
}

function createServerFn(_opts: { method: string }): ServerFnBuilder;
function createServerFn(_method: string, handler: AnyFn): AnyFn;
function createServerFn(...args: any[]): any {
  if (args.length === 1) {
    const builder: ServerFnBuilder = {
      middleware() { return builder; },
      inputValidator() { return builder; },
      handler(fn: AnyFn) {
        return (input: any) => fn(input);
      },
    };
    return builder;
  }
  return (input: any) => args[1](input);
}

function useServerFn(fn: AnyFn): AnyFn {
  return fn;
}

export { createServerFn, useServerFn };
